import type {
  CoreApiRequestPayload,
  CoreCustomerTaxProfile,
  CoreCustomerTaxProfilePayload,
  ParameterID,
} from '@flecto/types'

import { api } from '../../../services/api'
import { deserialize } from '../../../services/deserialize'

/**
 * Create a customer tax profiles by ID.
 *
 * @endpoint POST /api/saas/me/customers/{customerId}/tax_profiles
 * @scope saas
 * @see https://flecto.dev/api-4724213
 */
export async function createCustomerTaxProfile(
  customerId: ParameterID,
  taxProfile: CoreCustomerTaxProfilePayload
): Promise<CoreCustomerTaxProfile> {
  const body: CoreApiRequestPayload<CoreCustomerTaxProfilePayload> = {
    data: {
      type: 'customer_tax_profile',
      attributes: taxProfile,
    },
  }

  const response = await api.post(
    `/api/saas/me/customers/${customerId}/tax_profiles`,
    body
  )
  const { data } = deserialize<CoreCustomerTaxProfile>(response.data)

  return data
}
